import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"



import InvoiceHeader from "../components/invoice/InvoiceHeader"
import BillingInfoCard from "../components/invoice/BillingInfoCard"
import ShippingAddressCardInvoice from "../components/invoice/ShippingAddressCardinvoice"
import ItemsOrderedCard from "../components/invoice/ItemsOrderedCard"

function InvoiceScreen(){

const { id } = useParams()

const [order,setOrder] = useState(null)

useEffect(()=>{
  if (id) fetchOrder()
},[id])

const fetchOrder = async ()=>{

try{


const response = await fetch(`https://eleven11-i6v4.onrender.com/api/orders/${id}`)

if (!response.ok) {
  console.error("Order fetch failed");
  return;
}


const data = await response.json()

setOrder(data)

}catch(error){

console.error("Failed to load order",error)

}

}

if(!order){

return(
<div style={{padding:40}}>
Loading Invoice...
</div>
)

}

return(

<div style={styles.page}>



<div style={styles.wrapper}>

<InvoiceHeader order={order}/>

<div style={styles.grid}>

<BillingInfoCard order={order}/>

<ShippingAddressCardInvoice order={order}/>

</div>

<div style={styles.itemsLayout}>

<ItemsOrderedCard order={order}/>

</div>

<div style={{ textAlign: "center", marginTop: 30, marginBottom: 40 }}>
  <button
    onClick={() => window.location.href = `/account/orders/${order._id}`}
    style={{
      padding: "16px 40px",
      borderRadius: 999,
      border: "none",
      background: "#0f0f17",
      color: "#fff",
      fontSize: 15,
      fontWeight: 700,
      cursor: "pointer",
      boxShadow: "0 10px 24px rgba(0,0,0,0.12)"
    }}
  >
    View Order Tracking →
  </button>
</div>

</div>

</div>

)

}

export default InvoiceScreen



const styles={

page:{
minHeight:"100vh",
background:"#F4F6FB",
},

wrapper:{
maxWidth:1200,
margin:"40px auto",
padding:"0 40px"
},

grid:{
display:"grid",
gridTemplateColumns:"1fr 1fr",
gap:30,
marginTop:30
},

itemsLayout:{
marginTop:30
}

}